import { useId } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";

const QUESTIONS: readonly (readonly [string, string])[] = [
  ["What is it?", "Product, apparatus or device"],
  ["What is it made of?", "Composition of matter"],
  ["How does it work?", "Process / method"],
  ["What do you do with it?", "Method of use, use claims"],
  ["How do you make it?", "Method of manufacture, product-by-process"],
];

/** What a claim category is: the same invention answered to a different question. */
export function ClaimCategoriesDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const sentenceId = useId();
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent aria-describedby={sentenceId}>
        <DialogTitle>Claim categories</DialogTitle>
        <DialogDescription id={sentenceId} className="font-semibold">
          Every category is the same invention answered to a different question.
        </DialogDescription>
        <dl className="space-y-1 text-[12.5px]">
          {QUESTIONS.map(([question, answer]) => (
            <div key={question} className="flex gap-2">
              <dt className="font-semibold">{question}</dt>
              <dd>{answer}</dd>
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
